import { SdkContext } from './context/SdkContext';
import { GrFormClose } from 'react-icons/gr';
import RoomListItem from './ui/RoomListItem';
import React, { useContext, useEffect, useState } from 'react';
import { RoomContext } from './context/RoomContext';

export default function VideoRoomLobby() {
	const { roomInfo, setRoomInfo } = useContext(RoomContext);
	const sdk = useContext(SdkContext);
	const [roomTitle, setRoomTitle] = useState('');
	const [roomPw, setRoomPw] = useState('');
	const [roomList, setRoomList] = useState([]);
	const [joinModal, setJoinModal] = useState(false);
	const [reason, setReason] = useState('');
	const [enterPw, setEnterPw] = useState('');
	const [pwRoomInfo, setPwRoomInfo] = useState('');
	const updateErrorMsg = newData => {
		setReason(old => [...old, newData]);
	};
	const handleJoinRoom = async room => {
		try {
			const joinRoomResult = await sdk.joinRoom(room.room_id);
			setRoomInfo({
				...roomInfo,
				roomId: room.room_id,
				secret: room.secret,
				subject: room.subject,
				screen: joinRoomResult.screen,
				hasEnteredRoom: true,
			});
		} catch (error) {
			console.log(error);
		}
	};
	const handlePwJoinRoom = room => {
		setPwRoomInfo({
			roomId: room.room_id,
			secret: room.secret,
			subject: room.subject,
		});
		setJoinModal(true);
		setReason('');
	};

	const enterPwRoom = async () => {
		setReason('');
		try {
			const joinRoomResult = await sdk.joinRoom(pwRoomInfo.roomId, enterPw);

			setRoomInfo({
				...roomInfo,
				roomId: pwRoomInfo.roomId,
				subject: pwRoomInfo.subject,
				secret: pwRoomInfo.secret,
				screen: joinRoomResult.screen,
				hasEnteredRoom: true,
			});
		} catch (error) {
			updateErrorMsg(error);
			console.log(error);
		}
	};

	useEffect(() => {
		setTimeout(async function () {
			try {
				const sessionResult = await sdk.createSession();
				setRoomInfo({
					...roomInfo,
					session: sessionResult.session,
					userId: sessionResult.user_id,
				});
				await sdk.roomList('videoroom').then(roomResult => {
					setRoomList(roomResult.list);
				});

				sdk.on('close', () => {
					console.log('close Event');
					window.location.reload();
				});
			} catch (error) {
				console.log(error);
			}
		}, 1000);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sdk]);

	const handleCreateRoom = async () => {
		try {
			await sdk.createRoom('videoroom', roomTitle, roomPw);
			if (roomTitle !== undefined) {
				if (roomList !== undefined) {
					await sdk.roomList('videoroom').then(roomResult => {
						setRoomList(roomResult.list);
					});
				}
			}
			setRoomPw('');
			setRoomTitle('');
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<>
			{/* w-screen h-screen */}
			<div className="xs:px-5  flex flex-col items-center  bg-charcoal-300 ">
				{joinModal && (
					<div className="z-50   absolute top-[50%] bg-white w-[22rem] h-[16rem] rounded-lg ">
						<div className="flex justify-end mt-3 mr-5">
							<button
								onClick={() => {
									setJoinModal(false);
									setEnterPw('');
								}}
							>
								<GrFormClose className="inline-block w-7 h-7"></GrFormClose>
							</button>
						</div>
						<div className="mt-5">
							<div className="px-10  mb-5   text-center text-lg">
								비밀번호를 입력하세요
							</div>
							<div className="flex justify-center mb-5 ">
								<input
									className=" drop-shadow-md w-[80%] h-10"
									placeholder="비밀번호(숫자)"
									onChange={e => setEnterPw(e.target.value)}
								></input>
							</div>
							<div className="flex justify-center flex-col items-center">
								<span className=" text-red-500 mb-1">{reason}</span>
								<button
									className="p-2 px-4 bg-main text-white rounded-md"
									onClick={() => enterPwRoom()}
								>
									입장
								</button>
							</div>
						</div>
					</div>
				)}

				<div>
					<h1 className="text-white pt-40 text-3xl ">Video Conference</h1>
				</div>
				<div className="mt-10 sm:max-w-[36rem]  ">
					<div className="flex justify-end">
						<input
							className="w-[75%] h-12 rounded-md p-2 mr-2"
							type="text"
							placeholder="Room Title"
							value={roomTitle}
							onChange={e => setRoomTitle(e.target.value)}
						/>
						<input
							className="w-[25%] h-12 rounded-md p-2"
							type="password"
							placeholder="secret"
							value={roomPw}
							onChange={e => setRoomPw(e.target.value)}
						/>
					</div>
					<div className="flex w-[25%] ml-auto pb-14 border-b-1 border-white">
						<button
							className={`xs:text-xs text-white mt-4 w-full h-12 rounded-md p-2  ${
								roomTitle === ''
									? 'bg-charcoal-trans text-charcoal-400'
									: 'bg-light text-white'
							}`}
							type="button"
							disabled={roomTitle === ''}
							onClick={async () => {
								handleCreateRoom();
							}}
						>
							회의실 등록
						</button>
					</div>
					<span className="text-left text-white block border-b-[1px] pb-3 mb-5">
						방 목록
					</span>
				</div>
				<div className="w-full max-w-[25rem] ">
					{roomList &&
						roomList.map((room, i) => (
							<RoomListItem
								key={room.room_id}
								room={room}
								handleJoinRoom={handleJoinRoom}
								handlePwJoinRoom={handlePwJoinRoom}
								joinModal={joinModal}
								index={i} // Pass the index as a prop
							></RoomListItem>
						))}
				</div>
			</div>
		</>
	);
}
